/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ToothChartAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import HelpTooltip from './HelpTooltip/index'
import React from 'react'
import ToothChart from './ToothChart/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconTooth from 'DesignSystem/Svgs/TysiaIconTooth/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ToothChartAction({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/Secondary/ToothChartAction",
  hovered,
  onMouseEnter,
  onMouseLeave
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  hovered,
  onMouseEnter,
  onMouseLeave
  
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="ToothChartAction.Horizontal"
  data-view-path={viewPath}
 hovered={hovered}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--ml-1-Vy4RQ': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 onClick={onClick}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconTooth
{...childProps}
  viewPath={`${viewPath}/TysiaIconTooth`}
 fill={dtColorsWhite}
/>
)}
</TysiaButtonIcon>
<HelpTooltip
{...childProps}
  viewPath={`${viewPath}/HelpTooltip`}
 hovered={hovered}
/>
</React.Fragment>
)}
</TysiaButton>
</div>
<ToothChart
  viewPath={`${viewPath}/ToothChart`}
/>
{children}
</React.Fragment>)
}